var spoiler_default = {
  "fontElementMap": "-en6s",
  "hideText": "kCH-P",
  "onHoverText": "_7Vqb7",
  "hideBlock": "k4YEL",
  "smallBlur": "tc83J",
  "mediumBlur": "ZA-Dx",
  "largeBlur": "TWkGO",
  "hideBlock_gallery": "Ox3ic",
  "overlay": "OY-Yj",
  "overlay_gallery": "Am67F",
  "revealSpoilerBtn": "ZWgQ8",
  "isMobile": "Y8hUP",
  "onHoverBtn": "Djw9t",
  "spoilerWrapper": "be5Wp",
  "spoilerDescription": "Ar1WY",
  "spoilerContainer": "_17dKr",
  "spoilerContainer_Gallery": "jOIk3",
  "spoiler-text-blur": "fdnad"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
